<template>
    <div class="">
        <div class="flex justify-between flex-wrap items-center py-2">
            <SearchBar @name-selected="nameSelectedHandeler">
            </SearchBar>
            <div v-if="selectedServerName !== ''">
                <v-btn icon="mdi-delete" size="small" style="outline: none;" @click="deletePackages"
                    class="mr-5 bg-dark text-light"></v-btn>
                <v-btn prepend-icon="mdi-plus" size="small" style="outline: none;"
                    class="bg-dark text-light" @click="addProxy()" data-bs-toggle="modal"
                    data-bs-target="#packageAddModal">Add package</v-btn>
            </div>
        </div>
        <div v-if="loading === true" class=" flex items-center justify-center absolute custom-style " >
            <img src="../../../assets/loading.gif" class="w-[50px]"/>
        </div>
        <!-- packages grouped by server; UK / USA / Other tabs as on the Servers page. Sections start collapsed. -->
        <div v-if="selectedServerName === 'All'" class="pk-bar">
            <div class="region-tabs" role="tablist">
                <button v-for="r in REGIONS" :key="r.key" type="button" role="tab" class="region-tab"
                    :class="{ 'is-on': region === r.key }" :aria-selected="region === r.key" @click="region = r.key">
                    {{ r.label }} <span class="region-tab__count">{{ regionCounts[r.key] }}</span>
                </button>
            </div>
            <button type="button" class="pk-toggle" @click="toggleAll">{{ allOpen ? 'Collapse all' : 'Expand all' }}</button>
        </div>
        <div class="pk-groups" :style="{ maxHeight: computedHeight + 'px' }">
            <p v-if="!loading && !groups.length" class="pk-empty">No packages here.</p>
            <section v-for="g in groups" :key="g.name" class="pk-group">
                <button type="button" class="pk-head" :aria-expanded="isOpen(g)" @click="toggleGroup(g)">
                    <v-icon :icon="isOpen(g) ? 'mdi-chevron-down' : 'mdi-chevron-right'" size="18"></v-icon>
                    <span class="pk-head__name">{{ g.name }}</span>
                    <span class="pk-head__meta">{{ g.meta }}</span>
                    <span class="region-tab__count pk-head__count" :class="{ 'is-zero': !g.items.length }">{{ g.items.length }} {{ g.items.length === 1 ? 'package' : 'packages' }}</span>
                </button>
                <div v-if="!g.items.length" class="pk-none">
                    No packages yet.
                    <button type="button" class="pk-none__add" data-bs-toggle="modal" data-bs-target="#packageAddModal" @click="addProxy(g.name)">+ Add package</button>
                </div>
                <div v-if="isOpen(g) && g.items.length" class="pk-tablewrap">
                    <table class="pk-table">
                        <thead>
                            <tr><th></th><th>Package</th><th>Time Unit</th><th>Price</th><th>Status</th><th>Min IP Change Time(min)</th><th>ISP</th><th>Order</th><th>Actions</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in g.items" :key="item.uuid">
                                <td>
                                    <div @click="toggleSelection(item)" style="width: 20px; height: 20px; cursor: pointer; margin: 0 auto;">
                                        <input :checked="isSelected(item)" class="form-check-input shadow-none" type="checkbox" />
                                    </div>
                                </td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.time_unit }}</td>
                                <td>{{ item.price }}</td>
                                <td>{{ item.status }}</td>
                                <td>{{ item.min_time_change_ip }}</td>
                                <td>{{ item.isp }}</td>
                                <td>{{ item.seq }}</td>
                                <td>
                <v-menu offset-y location="bottom">
                    <template v-slot:activator="{ props, on, isActive }">
                        <v-btn v-bind="props" v-on="{ ...on }" density="compact"
                            :style="isActive ? 'border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;' : ''"
                            style="outline: none; font-size: 10px; " class="w-32 z-10 bg-dark text-light">
                            Actions
                            <v-icon icon="mdi-chevron-down" size="14"></v-icon>
                        </v-btn>
                    </template>
                    <v-list class="w-32 flex-1 flex flex-col px-0 py-0  z-0"
                        style="border-top-left-radius: 0px;border-top-right-radius: 0px">
                        <v-btn v-for="(button, index) in actionButtons" :key="index" @click="clickAction(item, button)"
                            rounded="0" class="text-center bg-dark text-light"
                            style="font-size: 10px; width: 128px; outline: none; border-bottom: 1px solid #345;"
                            :data-bs-toggle="button === 'Update' && 'modal'"
                            :data-bs-target="button === 'Update' && '#packageUpdateModal'">
                            {{button }}
                        </v-btn>
                    </v-list>
                </v-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </div>
    <div>
        <AddNewOneDialog @close="addNewOneDialogFlag = false" :serverName="presetServer" :listServer="selectedServerName" />
        <UpdateInfoDialog :item="selectedItem" @updated="updatedHandler" />
    </div>
</template>
<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useAdminPackageStore } from "@/stores"
import { storeToRefs } from 'pinia';
import SearchBar from './SearchBar.vue';
import AddNewOneDialog from "./Modals/AddNewOneDialog.vue"
import UpdateInfoDialog from "./Modals/UpdateInfoDialog.vue"

import { watchEffect } from 'vue';
import { useAdminProxyStore } from "@/stores"
const adminPackageStore = useAdminPackageStore()
// every server (with its country), so servers without packages still get a section
const { serverNames } = storeToRefs(useAdminProxyStore())
const { Packages, loading } = storeToRefs(adminPackageStore)

const selectedServerName = ref("")

// server categories (same as the Servers page): opens on UK; "Other" is every country that is not the UK or the USA
const REGIONS = [{ key: 'all', label: 'All' }, { key: 'uk', label: 'UK' }, { key: 'usa', label: 'USA' }, { key: 'other', label: 'Other' }]
const region = ref('uk')
const regionOf = (item) => {
    const c = String(item?.modem_country || '').trim().toLowerCase()
    if (['united kingdom', 'uk', 'great britain', 'england'].includes(c)) return 'uk'
    if (['united states', 'usa', 'us', 'united states of america'].includes(c)) return 'usa'
    return 'other'
}
const regionCounts = computed(() => {
    const counts = { uk: 0, usa: 0, other: 0, all: 0 }
    for (const item of Packages.value || []) { counts[regionOf(item)]++; counts.all++ }
    return counts
})
// one section per server, servers by name, packages inside by their Order number
const groups = computed(() => {
    const single = selectedServerName.value !== 'All'
    const map = new Map()
    for (const item of Packages.value || []) {
        if (!single && region.value !== 'all' && regionOf(item) !== region.value) continue
        const name = item.modem || 'No server'
        if (!map.has(name)) map.set(name, { name, meta: [item.modem_city, item.isp, item.modem_type].filter(Boolean).join(' · '), items: [] })
        map.get(name).items.push(item)
    }
    // servers with no packages yet: an empty section with "Add package"
    for (const s of serverNames.value || []) {
        if (!s?.name || s.name === 'All' || map.has(s.name)) continue
        if (single ? s.name !== selectedServerName.value : (region.value !== 'all' && regionOf({ modem_country: s.country }) !== region.value)) continue
        map.set(s.name, { name: s.name, meta: [s.modem_type, 'no packages'].filter(Boolean).join(' · '), items: [] })
    }
    const list = [...map.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }))
    for (const g of list) g.items.sort((a, b) => (Number(a.seq) || 0) - (Number(b.seq) || 0) || Number(a.price) - Number(b.price))
    return list
})
const openGroups = ref(new Set())
// a single chosen server is always shown open
const isOpen = (g) => selectedServerName.value !== 'All' || openGroups.value.has(g.name)
const toggleGroup = (g) => {
    const next = new Set(openGroups.value)
    if (next.has(g.name)) next.delete(g.name)
    else next.add(g.name)
    openGroups.value = next
}
const allOpen = computed(() => groups.value.length > 0 && groups.value.every((g) => openGroups.value.has(g.name)))
const toggleAll = () => { openGroups.value = allOpen.value ? new Set() : new Set(groups.value.map((g) => g.name)) }
const addNewOneDialogFlag = ref(false)
const selectedItems = ref([]);
const offsetHeight = 300; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const handleResize = () => {
  computedHeight.value = window.innerHeight - offsetHeight;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});
const isSelected = (item) => {
    return selectedItems.value.includes(item);
};
const toggleSelection = (item) => {
    const index = selectedItems.value.indexOf(item);
    if (index === -1) {
        selectedItems.value.push(item);
    } else {
        selectedItems.value.splice(index, 1);
    }
};
const nameSelectedHandeler = (name) => {
    if (name) {
        selectedServerName.value = name
        adminPackageStore.loadPackages(name)
    }
}
// Add package: from the top button (the chosen server, or pick one in the dialog) or from an empty server's section
const presetServer = ref('')
const addProxy = (serverName = null) => {
    presetServer.value = serverName || (selectedServerName.value !== 'All' ? selectedServerName.value : '')
    addNewOneDialogFlag.value = true
}
const deletePackages = () => {
    adminPackageStore.deletePackages(selectedItems.value.map(item => item.uuid)).then(() => {
        selectedItems.value = []
        adminPackageStore.loadPackages(selectedServerName.value)
    })

}




const actionButtons = ref(
    ["Update", "Delete"]
)
const updateInfoDialogFlag = ref(false)
const selectedItem = ref(null)

const openUpdateInfoDialog = (item) => {
    selectedItem.value = item
    updateInfoDialogFlag.value = true
}
const updatedHandler = () => {
    adminPackageStore.loadPackages(selectedServerName.value)
    updateInfoDialogFlag.value = false
}

const clickAction = (item, button) => {
    switch (button) {
        case "Update":
            openUpdateInfoDialog(item)
            break
        case "Delete":
            adminPackageStore.deletePackages([item.uuid]).then(() => {
                adminPackageStore.loadPackages(selectedServerName.value)
            })

    }
}
watchEffect(() => {
    if (selectedServerName.value !== '') {
        Packages.value = []
    }
}, [selectedServerName.value])
</script>

<style scoped>
.pk-bar { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 8px; margin: 4px 0 12px; }
.region-tabs { display: flex; flex-wrap: wrap; gap: 8px; }
.region-tab { display: inline-flex; align-items: center; gap: 8px; padding: 8px 14px; border: 1px solid var(--ui-line); border-radius: 10px; background: var(--ui-card); color: var(--ui-dim); font-size: 14px; font-weight: 600; cursor: pointer; }
.region-tab:hover, .region-tab:focus-visible { border-color: var(--ui-pri-hover); outline: none; }
.region-tab.is-on { border: 2px solid var(--ui-pri); padding: 7px 13px; background: var(--ui-pri-soft); color: var(--ui-ink); }
.region-tab__count { padding: 1px 8px; border-radius: 999px; background: var(--ui-line); color: var(--ui-ink); font-size: 12px; font-variant-numeric: tabular-nums; }
.region-tab.is-on .region-tab__count { background: var(--ui-pri); color: #ffffff; }
.pk-toggle { padding: 8px 14px; border: 1px solid var(--ui-line); border-radius: 10px; background: transparent; color: var(--ui-ink); font-size: 13px; cursor: pointer; }
.pk-toggle:hover { border-color: var(--ui-pri-hover); }
.pk-groups { display: grid; gap: 8px; overflow-y: auto; min-height: 300px; align-content: start; padding-right: 4px; }
.pk-empty { margin: 24px 0; text-align: center; color: var(--ui-dim); }
.pk-group { border: 1px solid var(--ui-line); border-radius: 12px; background: var(--ui-card); overflow: hidden; }
.pk-head { display: flex; align-items: center; gap: 10px; width: 100%; padding: 10px 12px; border: 0; background: var(--ui-pri-soft); color: var(--ui-ink); text-align: left; cursor: pointer; }
.pk-head:hover { background: var(--ui-card-2); }
.pk-head__name { font-size: 14px; font-weight: 600; }
.pk-head__meta { font-size: 12.5px; color: var(--ui-dim); }
.pk-head__count { margin-left: auto; }
.pk-tablewrap { overflow-x: auto; }
.pk-table { width: 100%; border-collapse: collapse; font-size: 13px; color: var(--ui-ink); }
.pk-table th { padding: 8px; font-size: 12px; font-weight: 600; color: var(--ui-dim); text-align: center; white-space: nowrap; }
.pk-table td { padding: 8px; border-top: 1px solid var(--ui-line); text-align: center; }

.custom-style {
    width: -webkit-fill-available; /* Safari/WebKit */
    height: -webkit-fill-available; /* Safari/WebKit */
    width: -moz-available; /* Firefox */
    height: -moz-available; /* Firefox */
    width: fill-available; /* Standard syntax, for future compatibility */
    height: fill-available; /* Standard syntax, for future compatibility */
}
</style>

<style scoped>
.pk-none { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; padding: 8px 14px 12px 40px; color: var(--ui-dim); font-size: 13px; }
.pk-none__add { padding: 4px 12px; border: 1px solid var(--ui-pri); border-radius: 999px; background: transparent; color: var(--ui-ink); font-size: 12.5px; font-weight: 600; cursor: pointer; }
.pk-none__add:hover { background: var(--ui-pri); color: #ffffff; }
.pk-head__count.is-zero { opacity: 0.6; }
</style>
